"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _reactReduxI18n = require("react-redux-i18n");

var _core = require("@material-ui/core");

var _reactDropzone = require("react-dropzone");

var _strings = require("../../utils/strings");

var _arrays = require("../../utils/arrays");

var _Icon = _interopRequireDefault(require("../Icon"));

var _TextSimpleAutocomplete = _interopRequireDefault(require("../TextSimpleAutocomplete"));

var _DocumentDossierChips = _interopRequireDefault(require("../DocumentDossierChips"));

var _UploadDropzone = _interopRequireDefault(require("./UploadDropzone"));

var _documents = require("../../utils/documents");

var _UploadHeaderView = _interopRequireDefault(require("./UploadHeaderView"));

var _upload = _interopRequireDefault(require("../../utils/upload"));

var _UploadFooterView = _interopRequireDefault(require("./UploadFooterView"));

var _UploadDocumentDetails = _interopRequireDefault(require("./UploadDocumentDetails"));

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DOCUMENT_MAX_SIZE = _upload.default.DOCUMENT_MAX_SIZE;
var DOCUMENT_MIN_SIZE = _upload.default.DOCUMENT_MIN_SIZE;

var UploadDocument = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(UploadDocument, _React$Component);

  var _super = _createSuper(UploadDocument);

  function UploadDocument(props, context) {
    var _props$document, _props$document$type;

    var _this;

    (0, _classCallCheck2.default)(this, UploadDocument);
    _this = _super.call(this, props, context);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildInfoForUpload", function () {
      return {
        additionalDesignation: _this.state.additionalDesignation.trim(),
        documentTypeCode: _this.state.documentType.code
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderAIAnalysisDisclaimer", function () {
      if (!_this.state.canBeValidatedByAI) {
        return null;
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "box info d-flex align-items-center",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "active mr-4",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            icon: "info",
            size: 28
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            whiteSpace: 'pre-line'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "document.uploadAIAnalysis.disclaimer"
          })
        })]
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderAIAnalysisResult", function () {
      var _this$props;

      if (!_this.state.canBeValidatedByAI || _this.props.loadingAIApi) {
        return null;
      }

      if (_this.props.aiExtractingStatusOK) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "box valid d-flex align-items-center",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "active mr-4",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
              icon: "check",
              className: "success",
              size: 28
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              display: 'inline-grid',
              whiteSpace: 'pre-line',
              lineHeight: '2rem'
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
              value: "document.uploadAIAnalysis.technicallyOK.line1"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
              value: "document.uploadAIAnalysis.technicallyOK.line2"
            })]
          })]
        });
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "box warning d-flex align-items-center",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "active mr-4",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            icon: "warning",
            className: "warning",
            size: 28
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            display: 'inline-grid',
            whiteSpace: 'pre-line',
            lineHeight: '2rem'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
              value: "document.uploadAIAnalysis.technicallyNotOK.line1_part1"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "clickable",
              "data-id": "document-technicallynotok-tooltip",
              tooltip: _reactReduxI18n.I18n.t('document.seeExample'),
              style: {
                cursor: 'pointer'
              },
              onClick: (_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.onDocumentExampleOpen,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
                value: "document.uploadAIAnalysis.technicallyNotOK.line1_cta"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
              value: "document.uploadAIAnalysis.technicallyNotOK.line1_part2"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "mt-3",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
              value: "document.uploadAIAnalysis.technicallyNotOK.line2"
            })
          })]
        })]
      });
    });
    _this.state = {
      fieldErrors: {},
      showFieldErrors: false,
      isSubmittable: false,
      file: null,
      additionalDesignation: props.document.additionalDesignation || '',
      documentType: props.document.type,
      documentTypeValue: null,
      disableSubtype: false,
      canBeValidatedByAI: Boolean(props === null || props === void 0 ? void 0 : (_props$document = props.document) === null || _props$document === void 0 ? void 0 : (_props$document$type = _props$document.type) === null || _props$document$type === void 0 ? void 0 : _props$document$type.aiValidationEnabled)
    };
    _this.validateFields = _this.validateFields.bind((0, _assertThisInitialized2.default)(_this));
    _this.checkIfSubmittable = _this.checkIfSubmittable.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDocumentTypeChange = _this.handleDocumentTypeChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleAdditionalDesignationChange = _this.handleAdditionalDesignationChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDropRejected = _this.handleDropRejected.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDrop = _this.handleDrop.bind((0, _assertThisInitialized2.default)(_this));
    _this.setSubtypeAndLock = _this.setSubtypeAndLock.bind((0, _assertThisInitialized2.default)(_this));
    _this.getFieldErrorText = _this.getFieldErrorText.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSubmit = _this.handleSubmit.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleAIVerification = _this.handleAIVerification.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UploadDocument, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkIfSubmittable();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var loadingAIApi = this.props.loadingAIApi;
      var _this$state = this.state,
          file = _this$state.file,
          documentType = _this$state.documentType,
          additionalDesignation = _this$state.additionalDesignation;
      var hasAIApiFinishedLoading = !loadingAIApi && prevProps.loadingAIApi;
      var hasFileChanged = file !== prevState.file;
      var hasDocumentTypeChanged = documentType !== prevState.documentType;
      var hasAdditionalDesignationChanged = additionalDesignation !== prevState.additionalDesignation;

      if (hasAIApiFinishedLoading || hasFileChanged || hasDocumentTypeChanged || hasAdditionalDesignationChanged) {
        this.checkIfSubmittable();
      }

      if (hasFileChanged && file || hasDocumentTypeChanged && documentType) {
        this.handleAIVerification();
      }
    }
  }, {
    key: "validateFields",
    value: function validateFields() {
      var fieldErrors = this.state.fieldErrors;
      var hasError = false;

      if (!this.state.file) {
        hasError = true;
      }

      if (this.state.documentType.designationMandatory) {
        var value = this.state.additionalDesignation;

        if ((0, _strings.isEmpty)(value) || value === false) {
          fieldErrors.additionalDesignation = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "error.required"
          });
          hasError = true;
        } else {
          fieldErrors.additionalDesignation = null;
        }
      }

      this.setState({
        fieldErrors: fieldErrors
      });
      return hasError;
    }
  }, {
    key: "checkIfSubmittable",
    value: function checkIfSubmittable() {
      this.setState({
        isSubmittable: !this.props.submitted && !this.validateFields() && !this.props.loadingAIApi
      });
    }
  }, {
    key: "handleAIVerification",
    value: function handleAIVerification() {
      if (this.state.canBeValidatedByAI && this.state.file) {
        var _this$props2;

        var info = this.buildInfoForUpload();
        (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onDocumentUploadWithAIVerification(this.props.document.uid, this.state.file, info);
      }
    }
  }, {
    key: "handleDocumentTypeChange",
    value: function handleDocumentTypeChange(documentTypeValue) {
      var _documentType;

      var documentType = this.state.documentType;

      if (documentTypeValue && documentTypeValue.value) {
        documentType = this.props.documentEquivalences.find(function (type) {
          return type.documentTypeId === documentTypeValue.value;
        });
      }

      this.setState({
        documentType: documentType,
        documentTypeValue: documentTypeValue,
        canBeValidatedByAI: Boolean((_documentType = documentType) === null || _documentType === void 0 ? void 0 : _documentType.aiValidationEnabled)
      });
    }
  }, {
    key: "handleAdditionalDesignationChange",
    value: function handleAdditionalDesignationChange(event) {
      this.setState({
        additionalDesignation: event.target.value
      });
    }
  }, {
    key: "handleDropRejected",
    value: function handleDropRejected(rejectedFile) {
      var fieldErrors = this.state.fieldErrors;

      switch (rejectedFile.errors[0].code) {
        case _reactDropzone.ErrorCode.FileTooLarge:
          fieldErrors.file = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "document.errorMaxSizeMessage",
            count: "15"
          });
          break;

        case _reactDropzone.ErrorCode.FileTooSmall:
          fieldErrors.file = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "document.errorMinSizeMessage",
            count: "1"
          });
          break;

        case _reactDropzone.ErrorCode.FileInvalidType:
          fieldErrors.file = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
              value: "document.errorTypeMessage"
            }), this.props.extensions.replace(/,/g, ' | ')]
          });
          break;

        default:
          fieldErrors.file = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "error.generic"
          });
      }

      this.setState({
        fieldErrors: fieldErrors
      });
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(acceptedFiles, rejectedFiles) {
      this.setSubtypeAndLock();

      if (!(0, _arrays.isEmpty)(acceptedFiles)) {
        this.setState(function (currentState) {
          return {
            fieldErrors: _objectSpread(_objectSpread({}, currentState.fieldErrors), {}, {
              file: null
            }),
            file: acceptedFiles[0]
          };
        });
      } else if (!(0, _arrays.isEmpty)(rejectedFiles)) {
        this.handleDropRejected(rejectedFiles[0]);
      }
    }
  }, {
    key: "setSubtypeAndLock",
    value: function setSubtypeAndLock() {
      if (this.state.documentTypeValue || this.props.document.type.abstractType) {
        return;
      }

      this.handleDocumentTypeChange({
        label: this.props.document.type.name,
        value: this.props.document.type.documentTypeId
      });

      if (this.props.lockSubtype) {
        this.setState({
          disableSubtype: true
        });
      }
    }
  }, {
    key: "getFieldErrorText",
    value: function getFieldErrorText(fieldName) {
      if (this.state.fieldErrors === null || typeof this.state.fieldErrors[fieldName] === 'undefined' || !this.state.showFieldErrors && fieldName !== 'file') {
        return null;
      }

      return this.state.fieldErrors[fieldName];
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      event.preventDefault();

      if (!this.state.isSubmittable) {
        this.setState({
          showFieldErrors: true
        });
        return;
      }

      var info = this.buildInfoForUpload();
      this.props.onHandleSubmitFile(this.props.document.uid, this.state.file, info);
    }
  }, {
    key: "getFileMessage",
    value: function getFileMessage() {
      return this.state.fieldErrors && this.state.fieldErrors.file ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "error",
        id: "error-file-message",
        children: this.getFieldErrorText('file')
      }) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3,
          _this2 = this;

      var equivalences = this.props.documentEquivalences.map(function (doc) {
        return {
          label: doc.name,
          value: doc.documentTypeId
        };
      });
      var errorFileMessage = this.getFileMessage();
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
        className: "p-0",
        onSubmit: this.handleSubmit,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadHeaderView.default, {
          documentName: this.state.documentType.name,
          hasExample: this.state.documentType.hasExample,
          onDocumentExampleOpen: (_this$props3 = this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onDocumentExampleOpen,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentDossierChips.default, {
            dossiers: this.props.document.dossiers
          })
        }), Boolean(this.props.message) && this.props.message, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "mt-4",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Collapse, {
            in: !this.state.file,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              children: [this.renderAIAnalysisDisclaimer(), /*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadDropzone.default, {
                file: this.state.file,
                extensions: this.props.extensions,
                onDrop: this.handleDrop,
                maxSize: DOCUMENT_MAX_SIZE,
                minSize: DOCUMENT_MIN_SIZE,
                errorFileMessage: errorFileMessage
              }), Boolean(this.props.secondaryMessage) && this.props.secondaryMessage]
            })
          })
        }), this.state.file && /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Fade, {
          in: true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [this.renderAIAnalysisResult(), /*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadDocumentDetails.default, {
              file: this.state.file,
              onRemoveFile: function onRemoveFile() {
                return _this2.setState({
                  file: null
                });
              },
              loadingApi: this.props.loadingAIApi
            }), this.props.showMetadataForm && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                id: "infosDiv",
                className: "mt-3",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextSimpleAutocomplete.default, {
                  label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
                    value: "document.documentType"
                  }),
                  error: Boolean(this.getFieldErrorText('documentType')),
                  helperText: this.getFieldErrorText('documentType'),
                  onChange: function onChange(event) {
                    return _this2.handleDocumentTypeChange(event.target.value);
                  },
                  suggestions: equivalences,
                  minimumCharsToRenderResults: 0,
                  maxResult: 5,
                  value: this.state.documentTypeValue,
                  disabled: this.state.disableSubtype
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
                label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
                    value: "document.additionalDesignation"
                  }), " ", this.state.documentType.designationMandatory && '*']
                }),
                id: "additionalDesignation",
                name: "additionalDesignation",
                error: Boolean(this.getFieldErrorText('additionalDesignation')),
                helperText: this.getFieldErrorText('additionalDesignation'),
                value: this.state.additionalDesignation,
                onChange: this.handleAdditionalDesignationChange,
                autoComplete: "off",
                InputProps: {
                  endAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment.default, {
                    position: "end",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      tooltip: _reactReduxI18n.I18n.t('document.additionalDesignationNotice'),
                      flow: "left",
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
                        icon: "info"
                      })
                    })
                  }),
                  inputProps: {
                    maxLength: 100
                  }
                }
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
                value: "message.textCounter",
                counter: this.state.additionalDesignation ? this.state.additionalDesignation.length : 0,
                maxLength: 100
              })]
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadFooterView.default, {
          submitted: this.props.submitted,
          isSubmittable: this.state.isSubmittable,
          onCancelClick: this.props.onCancel
        })]
      });
    }
  }]);
  return UploadDocument;
}(_react.default.Component);

UploadDocument.defaultProps = {
  showMetadataForm: true,
  extensions: '.pdf',
  lockSubtype: false,
  loadingAIApi: false,
  aiExtractingStatusOK: false,
  onDocumentUploadWithAIVerification: function onDocumentUploadWithAIVerification() {},
  onDocumentExampleOpen: function onDocumentExampleOpen() {}
};
UploadDocument.propTypes = {
  document: (0, _documents.documentPropTypes)().isRequired,
  documentEquivalences: _propTypes.default.array.isRequired,
  onCancel: _propTypes.default.func.isRequired,
  onHandleSubmitFile: _propTypes.default.func.isRequired,
  submitted: _propTypes.default.bool.isRequired,
  showMetadataForm: _propTypes.default.bool,
  onDocumentExampleOpen: _propTypes.default.func,
  extensions: _propTypes.default.string,
  onClickProject: _propTypes.default.func,
  message: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  secondaryMessage: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  lockSubtype: _propTypes.default.bool,
  onDocumentUploadWithAIVerification: _propTypes.default.func,
  loadingAIApi: _propTypes.default.bool.isRequired,
  aiExtractingStatusOK: _propTypes.default.bool.isRequired
};
var _default = UploadDocument;
exports.default = _default;
//# sourceMappingURL=UploadDocument.js.map